import { ThemeEnum } from '~/enums/Region'

export const assets = {
  [ThemeEnum.SHIPZEE]: {
    orderForm: {
      hero: () => import('/banners/order-form-hero.png'),
    },
    logos: {
      logo: () => import('@/assets/images/logo.svg'),
      logoBlack: () => import('@/assets/images/contacts-shipzee.png'),
      logoPro: () => import('@/assets/icons/pro-logo.svg'),
      logoWhite: () => import('@//assets/images/Logo-white.svg'),
      logoMini: () => import('@/assets/icons/h.svg'),
    },
    facebookLogo: {
      logo: () => import('@/assets/icons/icon-facebook.svg'),
    },
    usp: {
      icon1: () => import('@/assets/icons/icon-usp-platform.png'),
      icon2: () => import('@/assets/icons/icon-usp-delivery.png'),
      icon3: () => import('@/assets/icons/icon-usp-product.png'),
      icon4: () => import('@/assets/icons/icon-usp-special.png'),
    },
    whyJoin: {},
    proHowItWorks: {
      step1: () => import('@/assets/icons/pro-calculate/1-icon-curved.svg'),
      step2: () => import('@/assets/icons/pro-calculate/2-icon-curved.svg'),
      step3: () => import('@/assets/icons/pro-calculate/3-icon-curved.svg'),
      step4: () => import('@/assets/icons/pro-calculate/4-icon-curved.svg'),
    },
  },
  [ThemeEnum.PERKUJAV]: {
    quoteBenefits: {
      benefits: {
        icon1: () => import('@/assets/images/order-form/order-system.svg'),
        icon2: () => import('@/assets/images/order-form/payment.svg'),
        icon3: () => import('@/assets/images/order-form/phone-cart.svg'),
        icon4: () => import('@/assets/images/order-form/weight.svg'),
        icon5: () => import('@/assets/images/order-form/sales.svg'),
      },
      steps: {
        icon1: () => import('@/assets/images/order-form/how-it-works-1.png'),
        icon2: () => import('@/assets/images/order-form/how-it-works-2.png'),
        icon3: () => import('@/assets/images/order-form/how-it-works-3.png'),
        icon4: () => import('@/assets/images/order-form/how-it-works-4.png'),
      },
    },
    orderForm: {
      hero: () => import('/banners/perkujav-order-form-hero.png'),
    },
    logos: {
      logo: () => import('@/assets/images/perkujav-logo-white.svg'),
      logoBlack: () => import('@/assets/images/perkujav-logo.svg'),
      logoWhite: () => import('@/assets/images/perkujav-logo-white.svg'),
      logoPro: () => '',
      logoMini: () => import('@/assets/icons/h.svg'),
    },
    facebookLogo: {
      logo: () => import('@/assets/icons/fb-white.svg'),
    },
    usp: {
      icon1: () => import('@/assets/images/order-form/payment.svg'),
      icon2: () => import('@/assets/images/order-form/phone-cart.svg'),
      icon3: () => import('@/assets/images/order-form/weight.svg'),
      icon4: () => import('@/assets/images/order-form/sales.svg'),
      icon5: () => import('@/assets/images/order-form/order-system.svg'),
    },
    whyJoin: {},
    proHowItWorks: {},
  },
  [ThemeEnum.TARPININKE]: {
    quoteBenefits: {
      benefits: {
        icon1: () => import('@/assets/images/order-form/tp-benefit-1.svg'),
        icon2: () => import('@/assets/images/order-form/tp-benefit-2.svg'),
        icon3: () => import('@/assets/images/order-form/tp-benefit-3.svg'),
        icon4: () => import('@/assets/images/order-form/tp-benefit-4.svg'),
        icon5: () => import('@/assets/images/order-form/tp-benefit-5.svg'),
      },
      steps: {
        icon1: () => import('@/assets/images/order-form/tp-how-it-works-1.png'),
        icon2: () => import('@/assets/images/order-form/tp-how-it-works-2.png'),
        icon3: () => import('@/assets/images/order-form/tp-how-it-works-3.png'),
        icon4: () => import('@/assets/images/order-form/tp-how-it-works-4.png'),
      },
    },
    howItWorks: {
      icon1: () => import('@/assets/images/tarpininke/tp-index-how-it-works-1.png'),
      icon2: () => import('@/assets/images/tarpininke/tp-index-how-it-works-2.png'),
      icon3: () => import('@/assets/images/tarpininke/tp-index-how-it-works-3.png'),
      icon4: () => import('@/assets/images/tarpininke/tp-index-how-it-works-4.png'),
      icon5: () => import('@/assets/images/tarpininke/tp-index-how-it-works-5.png'),
    },
    whyJoin: {
      icon1: () => import('@/assets/images/tarpininke/tp-index-benefit-1.svg'),
      icon2: () => import('@/assets/images/tarpininke/tp-index-benefit-2.svg'),
      icon3: () => import('@/assets/images/tarpininke/tp-index-benefit-3.svg'),
      icon4: () => import('@/assets/images/tarpininke/tp-index-benefit-4.svg'),
    },
    orderForm: {
      hero: () => import('/banners/tp-order-form-hero.png'),
    },
    logos: {
      logo: () => import('@/assets/images/tp-logo.svg'),
      logoWhite: () => import('@/assets/images/tp-logo.svg'),
      logoBlack: () => import('@/assets/images/tp-logo-black.svg'),
      logoPro: () => '',
      logoMini: () => import('@/assets/icons/tp-mini.svg'),
    },
    facebookLogo: {
      logo: () => import('@/assets/icons/fb-white.svg'),
    },
    usp: {
      icon1: () => import('@/assets/images/tarpininke/tp-usp1.svg'),
      icon2: () => import('@/assets/images/tarpininke/tp-usp2.svg'),
      icon3: () => import('@/assets/images/tarpininke/tp-usp3.svg'),
      icon4: () => import('@/assets/images/tarpininke/tp-usp4.svg'),
      icon5: () => import('@/assets/images/tarpininke/tp-usp5.svg'),
    },
    proHowItWorks: {},
  },
  [ThemeEnum.WHITELABEL]: {
    quoteBenefits: {
      benefits: {
        icon1: () => '',
        icon2: () => '',
        icon3: () => '',
        icon4: () => '',
        icon5: () => '',
      },
      steps: {
        icon1: () => '',
        icon2: () => '',
        icon3: () => '',
        icon4: () => '',
      },
    },
    orderForm: {
      hero: () => import('/banners/wl-order-form-hero.png'),
    },
    logos: {
      logo: () => import('@/assets/images/wl-logo.svg'),
      logoBlack: () => import('@/assets/images/wl-logo.svg'),
      logoWhite: () => import('@//assets/images/wl-logo.svg'),
      logoPro: () => import('@/assets/images/wl-logo.svg'),
      logoMini: () => import('@/assets/icons/h.svg'),
    },
    howItWorks: {
      icon1: () => import('@/assets/images/whitelabel/wl-index-how-it-works-1.png'),
      icon2: () => import('@/assets/images/whitelabel/wl-index-how-it-works-2.png'),
      icon3: () => import('@/assets/images/whitelabel/wl-index-how-it-works-3.png'),
      icon4: () => import('@/assets/images/whitelabel/wl-index-how-it-works-4.png'),
    },
    facebookLogo: {
      logo: () => import('@/assets/icons/fb-white.svg'),
    },
    usp: {
      icon1: () => import('@/assets/images/whitelabel/wl-index-how-it-works-1.png'),
      icon2: () => import('@/assets/images/whitelabel/wl-index-how-it-works-2.png'),
      icon3: () => import('@/assets/images/whitelabel/wl-index-how-it-works-3.png'),
      icon4: () => import('@/assets/images/whitelabel/wl-index-how-it-works-4.png'),
    },
    whyJoin: {},
    proHowItWorks: {
      step1: () => import('@/assets/icons/pro-calculate/wl-icon-curved-1.svg'),
      step2: () => import('@/assets/icons/pro-calculate/wl-icon-curved-2.svg'),
      step3: () => import('@/assets/icons/pro-calculate/wl-icon-curved-3.svg'),
      step4: () => import('@/assets/icons/pro-calculate/wl-icon-curved-4.svg'),
    },
  },
  [ThemeEnum.NORIULIVE]: {
    quoteBenefits: {
      benefits: {
        icon1: () => import('@/assets/images/order-form/tp-benefit-1.svg'),
        icon2: () => import('@/assets/images/order-form/tp-benefit-2.svg'),
        icon3: () => import('@/assets/images/order-form/tp-benefit-3.svg'),
        icon4: () => import('@/assets/images/order-form/tp-benefit-4.svg'),
        icon5: () => import('@/assets/images/order-form/tp-benefit-5.svg'),
      },
      steps: {
        icon1: () => import('@/assets/images/order-form/tp-how-it-works-1.png'),
        icon2: () => import('@/assets/images/order-form/tp-how-it-works-2.png'),
        icon3: () => import('@/assets/images/order-form/tp-how-it-works-3.png'),
        icon4: () => import('@/assets/images/order-form/tp-how-it-works-4.png'),
      },
    },
    howItWorks: {
      icon1: () => import('@/assets/images/tarpininke/tp-index-how-it-works-1.png'),
      icon2: () => import('@/assets/images/tarpininke/tp-index-how-it-works-2.png'),
      icon3: () => import('@/assets/images/tarpininke/tp-index-how-it-works-3.png'),
      icon4: () => import('@/assets/images/tarpininke/tp-index-how-it-works-4.png'),
      icon5: () => import('@/assets/images/tarpininke/tp-index-how-it-works-5.png'),
    },
    orderForm: {
      hero: () => import('/banners/tp-order-form-hero.png'),
    },
    logos: {
      logo: () => import('@/assets/images/nl-logo.svg'),
      logoWhite: () => import('@/assets/images/nl-logo-white.svg'),
      logoBlack: () => import('@/assets/images/nl-logo-black.svg'),
      logoMini: () => import('@/assets/icons/h.svg'),
    },
    whyJoin: {
      icon1: () => import('@/assets/images/noriulive/nl-index-benefit-1.png'),
      icon2: () => import('@/assets/images/noriulive/nl-index-benefit-2.png'),
      icon3: () => import('@/assets/images/noriulive/nl-index-benefit-3.png'),
      icon4: () => import('@/assets/images/noriulive/nl-index-benefit-4.png'),
    },
    facebookLogo: {
      logo: () => import('@/assets/icons/fb-white.svg'),
    },
  },
  [ThemeEnum.AMEERIKAEESTIS]: {
    quoteBenefits: {
      benefits: {
        icon1: () => import('@/assets/images/order-form/ae-benefit-1.svg'),
        icon2: () => import('@/assets/images/order-form/ae-benefit-2.svg'),
        icon3: () => import('@/assets/images/order-form/ae-benefit-3.svg'),
        icon4: () => import('@/assets/images/order-form/ae-benefit-4.svg'),
        icon5: () => import('@/assets/images/order-form/ae-benefit-5.svg'),
      },
      steps: {
        icon1: () => import('@/assets/images/order-form/ae-how-it-works-1.png'),
        icon2: () => import('@/assets/images/order-form/ae-how-it-works-2.png'),
        icon3: () => import('@/assets/images/order-form/ae-how-it-works-3.png'),
        icon4: () => import('@/assets/images/order-form/ae-how-it-works-4.png'),
      },
    },
    howItWorks: {
      icon1: () => import('@/assets/images/ameerika-eestis/ae-index-how-it-works-1.png'),
      icon2: () => import('@/assets/images/ameerika-eestis/ae-index-how-it-works-2.png'),
      icon3: () => import('@/assets/images/ameerika-eestis/ae-index-how-it-works-3.png'),
      icon4: () => import('@/assets/images/ameerika-eestis/ae-index-how-it-works-4.png'),
      icon5: () => import('@/assets/images/ameerika-eestis/ae-index-how-it-works-5.png'),
    },
    whyJoin: {
      icon1: () => import('@/assets/images/ameerika-eestis/ae-index-benefit-1.svg'),
      icon2: () => import('@/assets/images/ameerika-eestis/ae-index-benefit-2.svg'),
      icon3: () => import('@/assets/images/ameerika-eestis/ae-index-benefit-3.svg'),
      icon4: () => import('@/assets/images/ameerika-eestis/ae-index-benefit-4.svg'),
    },
    orderForm: {
      hero: () => import('/banners/tp-order-form-hero.png'),
    },
    logos: {
      logo: () => import('@/assets/images/ae-logo.svg'),
      logoWhite: () => import('@/assets/images/ae-logo.svg'),
      logoBlack: () => import('@/assets/images/ae-logo.svg'),
      logoMini: () => import('@/assets/icons/ae-mini.svg'),
    },
    facebookLogo: {
      logo: () => import('@/assets/icons/fb-white.svg'),
    },
    usp: {
      icon1: () => import('@/assets/images/tarpininke/tp-usp1.svg'),
      icon2: () => import('@/assets/images/tarpininke/tp-usp2.svg'),
      icon3: () => import('@/assets/images/tarpininke/tp-usp3.svg'),
      icon4: () => import('@/assets/images/tarpininke/tp-usp4.svg'),
      icon5: () => import('@/assets/images/tarpininke/tp-usp5.svg'),
    },
  },
}

export type Assets = typeof assets
